import { render, staticRenderFns } from "./1x2FB.vue?vue&type=template&id=49d8b7c8&scoped=true&"
import script from "./1x2FB.vue?vue&type=script&lang=js&"
export * from "./1x2FB.vue?vue&type=script&lang=js&"
import style0 from "./1x2FB.vue?vue&type=style&index=0&id=49d8b7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8b7c8",
  null
  
)

export default component.exports